import Post from '../../components/Post';
import usePost from '../../hooks/usePost';

const PostPage: React.FC<{ id: number }> = ({ id }) => {
  const post = usePost(id.toString());
  if (!post) return null;
  return <Post post={post} page />;
};

export default PostPage;
